import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        if (pathname === '/checkout') {
            // Temporarily disable smooth scroll
            const html = document.documentElement;
            const prevScrollBehavior = html.style.scrollBehavior;
            html.style.scrollBehavior = 'auto';

            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0;

            // Restore previous scroll behavior after a short delay
            setTimeout(() => {
                html.style.scrollBehavior = prevScrollBehavior || '';
            }, 100);
        }
    }, [pathname]);

    return null;
};

export default ScrollToTop;
